var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2067",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 220C143.333 220 129.167 214.167 117.5 202.5C105.833 190.833 100 176.667 100 160C100 143.333 105.833 129.167 117.5 117.5C129.167 105.833 143.333 100 160 100C176.667 100 190.833 105.833 202.5 117.5C214.167 129.167 220 143.333 220 160C220 176.667 214.167 190.833 202.5 202.5C190.833 214.167 176.667 220 160 220ZM160 200C171 200 180.417 196.083 188.25 188.25C196.083 180.417 200 171 200 160C200 149 196.083 139.583 188.25 131.75C180.417 123.917 171 120 160 120C149 120 139.583 123.917 131.75 131.75C123.917 139.583 120 149 120 160C120 171 123.917 180.417 131.75 188.25C139.583 196.083 149 200 160 200ZM40 200C34.5 200 29.7917 198.042 25.875 194.125C21.9583 190.208 20 185.5 20 180V104C20 102.667 20.125 101.333 20.375 100C20.625 98.6667 21 97.3333 21.5 96L41.5 50H40C37.1667 50 34.7917 49.0417 32.875 47.125C30.9583 45.2083 30 42.8333 30 40V30C30 27.1667 30.9583 24.7917 32.875 22.875C34.7917 20.9583 37.1667 20 40 20H110C112.833 20 115.208 20.9583 117.125 22.875C119.042 24.7917 120 27.1667 120 30V40C120 42.8333 119.042 45.2083 117.125 47.125C115.208 49.0417 112.833 50 110 50H108.5L125 88C121.833 89.6667 118.833 91.4167 116 93.25C113.167 95.0833 110.5 97.1667 108 99.5L87 50H63L40 104V180H82.5C83.3333 183.5 84.4583 186.958 85.875 190.375C87.2917 193.792 89 197 91 200H40ZM160 90C153 90 147.083 87.5833 142.25 82.75C137.417 77.9167 135 72 135 65C135 58 137.417 52.0833 142.25 47.25C147.083 42.4167 153 40 160 40V90C160 83 162.417 77.0833 167.25 72.25C172.083 67.4167 178 65 185 65C192 65 197.917 67.4167 202.75 72.25C207.583 77.0833 210 83 210 90H160Z",
    fill: "url(#paint0_linear_1_2067)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2067",
    x1: 120,
    y1: 20,
    x2: 120,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDDF98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5F2D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkbg);
export default __webpack_public_path__ + "static/media/workbg.ea1dd9d422dcb1bbc737367c5fee3d88.svg";
export { ForwardRef as ReactComponent };